module.exports = __webpack_public_path__ + "img/1-2.4815e5b1.jpg";